import React from "react"
import { Box, Paper, Typography } from "@mui/material"

export default function PaperWithHeading({
  title,
  backgroundColor = "rgb(4 110 0)",
  children,
}) {
  return (
    <Paper>
      <Box style={{ backgroundColor: backgroundColor }}>
        <Typography variant="h5" style={{ padding: 10, color: "#fafafa" }}>
          {title}
        </Typography>
      </Box>
      <Box style={{ padding: 20 }}>{children}</Box>
    </Paper>
  )
}
